<template>
  <div>
    <Signup/>
  </div>
</template>

<script>
import Signup from '@/components/Signup'

export default {
  name: 'SignupPage',
  components: {
    Signup
  }
}
</script>